import Vue from "vue";
import Vuex from "vuex";
import global from "./GlobalStore/GlobalStore";
import filter from "./FiltersStore/FiltersStore";
import Report from "./ReportStore/ReportStore";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    filter,
    Report
  }
});
